// @flow

export const Canvas = "canvas";
export const path2D = (_: HTMLCanvasElement, path: string) => {
  // $FlowFixMe
  return new Path2D(path);
};
